module.exports = __webpack_public_path__ + "static/media/sweet_9_tablet.94f36322.png";